import { useEffect, useState, type ReactNode } from "react";

// Email is assembled in the browser so the raw address never appears in the static HTML.
const parts = ["johnbanistean", "yahoo.com"];

export const ProtectedEmail = ({ className, children }: { className?: string; children?: ReactNode }) => {
  const [email, setEmail] = useState("");
  useEffect(() => setEmail(parts.join("@")), []);
  return (
    <a href={email ? `mailto:${email}` : undefined} className={className}>
      {children}
      {email}
    </a>
  );
};

export default ProtectedEmail;
